import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { LoadingOverlay } from '../ui/LoadingOverlay';

export function OnboardingGate({ children }) {
  const { initializing, needsOnboarding } = useAuth();

  if (initializing) {
    return <LoadingOverlay loading />;
  }

  if (needsOnboarding) {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
}
